import PropTypes from 'prop-types';
import { icons } from '@chillibean/component-library/legacy';

import TextField from '../TextField/TextField';

function SearchInput(props) {
  const { id, placeholderText, handleOnChange, value, customStyle } = props;

  return (
    <div className="search-input" style={customStyle}>
      <TextField fieldName={placeholderText} handleChange={handleOnChange} value={value} fieldID={id} />

      <button type="submit">
        <i>{icons.search()}</i>
      </button>
    </div>
  );
}

SearchInput.propTypes = {
  id: PropTypes.string,
  placeholderText: PropTypes.string,
  handleOnChange: PropTypes.func,
  value: PropTypes.string,
  customStyle: PropTypes.object,
};

export default SearchInput;
